import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router';
import { useTheme } from "@mui/material/styles";
import { useCrawlingChatbotAuth } from '../Auth/CrawlingChatbotAuthProvider';

export default function Header() {
  const { crawlingChatbotLogout } = useCrawlingChatbotAuth();
  const navigate = useNavigate();
  const handleClick = () => {
    window.location.reload();
  };
  const [shouldShowLogout, setShouldShowLogout] = React.useState(window.location.hash.includes('/crawling/index'));

  const handleLogout = () => {
    localStorage.removeItem('crawling');
    crawlingChatbotLogout();
    navigate('/crawling/signin');
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div
      style={{
        backgroundColor: 'rgb(28, 113, 198)',
        padding: '10px 20px',
        textAlign: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Typography
        variant="h6"
        component="div"
        sx={{
          color: 'rgb(255, 255, 255)',
          fontWeight: 'bold',
          cursor: 'pointer',
          '&:hover': { opacity: 0.7 }
        }}
        onClick={handleClick}
      >
        Smart AI Virtual Assistance
      </Typography>

      <div>
      {/* <Button
        variant="soft"
        color="neutral"
        sx={{
          mr: 1,
          backgroundColor: 'rgb(255, 255, 255)',
          color: 'black',
          fontSize : isSmallScreen ? '10px' : '14px',
        }}
        onClick={() => navigate('/')}
      >
        Home
      </Button> */}
      {shouldShowLogout && (<Button onClick={() => window.location.reload()} variant="contained" sx={{color : 'white' ,  fontSize : isSmallScreen ? '10px' : '14px',marginRight : '10px' ,backgroundColor: 'green' }}>
        Refresh
        </Button>)}
      <Button onClick={() => navigate('/')} variant="contained" sx={{color : 'black' ,  fontSize : isSmallScreen ? '10px' : '14px',marginRight : '10px' ,backgroundColor: 'rgb(255, 255, 255)' }}>
        Home
        </Button>
      {shouldShowLogout && (
        <Button variant="contained" color="secondary" onClick={handleLogout} sx={{ fontSize : isSmallScreen ? '10px' : '14px',marginRight : '10px' ,backgroundColor: 'rgb(197, 26, 26)' }}>
          Logout
        </Button>
      )}
      
      </div>
    </div>
  );
}
